import * as React from 'react';
import { Button, Dialog, DialogActions, DialogTitle } from '@material-ui/core';
import { OptOutModalProps } from './ElementTypeInterfaces';

const OptOutModal: React.FunctionComponent<OptOutModalProps> = (props) => {
  const {
    openOptOutModal,
    modalInfo,
    onCancelClickHandler,
    modalCancel,
    modalOk,
    link,
  } = props;

  return (
    <div>
      <Dialog open={openOptOutModal} data-test-id="opt-out-modal">
        <DialogTitle>{modalInfo}</DialogTitle>
        <DialogActions>
          <Button color="secondary" onClick={onCancelClickHandler}>
            {modalCancel}
          </Button>
          <Button color="primary" href={link} data-test-id="opt-out-link">
            {modalOk}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default OptOutModal;
